<template>
  <div class="citizen-account">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/buergerkonto">Bürgerkonto</router-link>
    </Breadcrumb>
    <div class="wrapper margin-top--40">
      <div class="headline-link">
        <div class="headline-link__headline">
          <Icon icon="augsburg" color="detailed" class="hide-mobile"/>
          <Headline subline="Ihr Augsburger Bürgerkonto" :headline="headline" />
        </div>
        <div class="headline-link__right hide-mobile">
          <Icon icon="weather" color="detailed"/>
          <div>
            <p>Augsburg Innenstadt</p>
            <p>8°C, bewölkt <span>- {{time}} Uhr</span></p>
          </div>
        </div>
      </div>
    </div>

    <div class="menu">
      <div class="wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <router-link to="/buergerkonto/dokumentenbox" class="menu__point">
              <Icon icon="docBox" color="detailed" />
              <div class="menu__point__text">
                <h3 class="margin-bottom--10">Meine Dokumentenbox</h3>
                <p>{{ userDocs.length }} Dokumente<span v-if="unseenDocs.length > 0"> - {{ unseenDocs.length }} Neue</span></p>
              </div>
            </router-link>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <router-link to="/buergerkonto/postbox" class="menu__point">
              <Icon icon="postBox" color="detailed" />
              <div class="menu__point__text">
                <h3 class="margin-bottom--10">Meine Postbox</h3>
                <p>{{ messages.length }} Nachrichten<span v-if="unreadMessages.length > 0"> - {{ unreadMessages.length }} Neue</span></p>
              </div>
            </router-link>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <router-link to="/buergerkonto/einstellungen" class="menu__point">
              <Icon icon="settings" color="detailed" />
              <div class="menu__point__text">
                <h3 class="margin-bottom--10">Profil & Einstellungen</h3>
                <p>Privatssphäre & Datenschutz</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="proposals wrapper margin-bottom--70">
      <h3 class="margin-bottom--10">Bearbeitungsstand Ihrer Anträge</h3>
      <div class="greenline margin-bottom--30"></div>
      <div class="proposal">
        <router-link to="/buergerkonto/aktivitaeten" class="proposal__top">
          <Icon icon="checkForm" color="detailed" />
          <div class="text">
            <h3 class="margin-bottom--10">Antrag auf Ausbildungsförderung (BAföG) für Studenten</h3>
            <p><span>Ihr Antrag wird aktuell geprüft.</span> Wir informieren Sie sobald sich der status ändert.</p>
          </div>
          <Icon icon="arrowRight" class="hide-mobile"/>
        </router-link>
        <div class="proposal__bottom">
          <div class="row">
            <div class="proposal__bottom__left col-xs-12 col-sm-6">
              <table>
                <tr>
                  <td>Datum der Antragsstellung:</td>
                  <td>02.02.2019</td>
                </tr>
                <tr>
                  <td>Zuständige Behörde:</td>
                  <td>Amt für Ausbildungsförderung</td>
                </tr>
              </table>
            </div>
            <div class="proposal__bottom__right col-xs-12 col-sm-6">
              <table>
                <tr>
                  <td>Nächster Schritt:</td>
                  <td>Bearbeitung Ihres Antrags</td>
                </tr>
                <tr>
                  <td>Kontakt:</td>
                  <td>bafoeg@augsburg.de</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="proposal">
        <router-link to="/buergerkonto/aktivitaeten" class="proposal__top">
          <Icon icon="certificate" color="detailed" />
          <div class="text">
            <h3 class="margin-bottom--10">Beantragung eines Führungszeugnises</h3>
            <p><span>Ihr Antrag wurde abgeschlossen.</span> Das beantragte Dokument liegt in Ihrer Dokumentenbox für Sie bereit.</p>
          </div>
          <Icon icon="arrowRight" class="hide-mobile"/>
        </router-link>
      </div>
      <router-link to="/buergerkonto/aktivitaeten" class="link margin-top--40"><Icon icon="arrowRight" color="green"/>Alle Anträge ansehen</router-link>
    </div>

    <div class="wrapper">
      <div class="row">
        <!-- PostBox Teaser-->
        <router-link to="buergerkonto/postbox" class="col-xs-12 col-md-6">
          <h3 class="margin-bottom--10">Ihre Postbox</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="postbox">
            <Card padding="0">
              <div class="postbox__top">
                <Icon icon="postBox" color="detailed" />
                <div class="text">
                  <h3 class="margin-bottom--10">{{ messages.length }} Nachrichten</h3>
                  <p>Wichtige Mitteilungen rund um Augsburg und Ihre Anliegen.</p>
                </div>
              </div>
              <div class="postbox__bottom">
                <router-link v-for="(message, index) in messages" :key="message.id" v-show="index < 6" to="buergerkonto/postbox" class="message">
                  <div class="message__text">
                    <p :class="{'new' : !message.read}">{{ message.subject }}</p>
                    <p>{{ message.author }}</p>
                  </div>
                  <Icon icon="arrowRight" />
                </router-link>
                <router-link to="/buergerkonto/postbox" class="link margin-top--30"><Icon icon="arrowRight" color="green"/>Alle Nachrichten</router-link>
              </div>
            </Card>
          </div>
        </router-link>
        <!-- DocBox Teaser-->
        <router-link to="buergerkonto/dokumentenbox" class="col-xs-12 col-md-6">
          <h3 class="margin-bottom--10">Ihre Dokumentenbox</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="docbox">
            <Card padding="0">
              <div class="docbox__top">
                <Icon icon="docBox" color="detailed" />
                <div class="text">
                  <h3 class="margin-bottom--10">{{ userDocs.length }} Dokumente</h3>
                  <p>Alle persönlichen Dokumente, Nachweise, Anträge und Dateien</p>
                </div>
              </div>
              <div class="docbox__bottom">
                <router-link v-for="folder in folders" :key="folder.id" to="buergerkonto/dokumentenbox" class="doc">
                  <Icon icon="folder" />
                  <p>{{ folder.name }}</p>
                  <div class="folder-size hide-mobile"><Icon icon="file"/>{{ folder.docs.length }} Dateien</div>
                </router-link>
                <router-link v-for="(doc, index) in userDocs" v-show="index < 3" :key="doc.id" to="buergerkonto/dokumentenbox" class="doc">
                  <Icon icon="file" />
                  <p :class="{'new' : !doc.seen}">{{ doc.name }}</p>
                  <Icon icon="arrowRight"/>
                </router-link>
                <router-link to="/buergerkonto/dokumentenbox" class="link margin-top--30"><Icon icon="arrowRight" color="green"/>Alle Dokumente</router-link>
              </div>
            </Card>
          </div>
        </router-link>
      </div>
    </div>


    <div class="wrapper margin-top--70">
      <Headline subline="Anhand Ihrer Lebenslage" headline="Vorgeschlagene Services" />
      <transition-group name="list" class="row">
        <div v-for="service in suggestedServices" :key="service.id" class="list-item col-xs-12 col-sm-6 col-md-3">
          <ServiceCard :service="service"/>
        </div>
      </transition-group>
      <router-link to="/services" class="link margin-top--20"><Icon icon="arrowRight" color="green"/>Alle Services</router-link>
    </div>

    <div class="wrapper spc">
      <Headline class="margin-bottom--40 margin-top--90" subline="Ihr Kontakt zu uns" headline="Ihr einheitlicher Ansprechpartner" />
    </div>
    <div class="teaser">
      <div class="wrapper">
        <div class="row">
          <div class="spc__data col-xs-12 col-sm-4">
            <h6>{{ activeUser.spc }}</h6>
            <p>Bürgeramt Augsburg Innenstadt</p>
            <p>An der Blauen Kappe 18</p>
            <p>86152 Augsburg</p>
            <h6>Kontakt</h6>
            <table>
              <tr>
                <td>Telefon:</td>
                <td><a href="tel:+49 821 598-4901">+49 821 598-4901</a></td>
              </tr>
              <tr>
                <td>E-Mail:</td>
                <td><a href="mailto:weisberger@augsburg.services">kontakt@augsburg.services</a></td>
              </tr>
            </table>
          </div>
          <div class="spc__data col-xs-12 col-sm-4">
            <h6>Telefonische Sprechzeiten</h6>
            <table>
              <tr>
                <td>Mo, Mi, Fr:</td>
                <td>08:30 Uhr - 12:30 Uhr</td>
              </tr>
              <tr>
                <td>Do:</td>
                <td>13:00 - 16:00 Uhr</td>
              </tr>
            </table>
            <h6>Chat-Auskunft</h6>
            <table>
              <tr>
                <td>Status:</td>
                <td class="status">Gerade Online</td>
              </tr>
              <tr>
                <td>Chat:</td>
                <td>Chat öffnen</td>
              </tr>
            </table>
          </div>
          <div class="spc__img col-xs-12 col-sm-4 hide-mobile">
            <img src="../../assets/images/spc.png" alt="Ansprechpartner">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import ServiceCard from '../../components/ServiceCard/ServiceCard';

export default {
  name: 'CitizenAccount',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    ServiceCard,
  },
  data() {
    return {
      doneServices: null,
      suggestedServices: null,
      messages: null,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      getServicesByIds: 'services/getServicesByIds',
      getMessagesByIds: 'messages/getMessagesByIds',
      getUnreadMessages: 'messages/getUnreadMessages',
      folders: 'documents/getAllFolders',
      userDocs: 'documents/getAllDocs',
    }),
    time() {
      const newTime = new Date();
      return newTime.toLocaleTimeString('de-DE', { hour12: false, 
                                             hour: "numeric", 
                                             minute: "numeric"});
    },
    headline() {
      if(this.activeUser.sex === 'male') {
        return `Guten Tag, Herr ${this.activeUser.lastName}`;
      } else {
        return `Guten Tag, Frau ${this.activeUser.lastName}`;
      }
    },
    unreadMessages(){
      return this.messages.filter(message => !message.read);
    },
    unseenDocs(){
      return this.userDocs.filter(doc => !doc.seen);
    }
  },
  methods: {
  },
  created() {
    this.doneServices = this.getServicesByIds(this.activeUser.doneServices);
    this.suggestedServices = this.getServicesByIds([102,103,104,105]);
    this.messages = this.getMessagesByIds(this.activeUser.id);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./CitizenAccount.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/CitizenAccount/CitizenAccount.vue